import React from 'react'

import T from 'components/FormattedMessage'

import Grid from '@material-ui/core/Grid'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Switch from '@material-ui/core/Switch'
import Typography from '@material-ui/core/Typography'

import { NotificationSettingsResponse } from 'protos'

interface Props {
  notificationSettings: NotificationSettingsResponse
  onNotificationToggle: (id: string, enabled: boolean) => any // tslint:disable-line:no-any
}

const NotificationSwitchers = ({ notificationSettings, onNotificationToggle }: Props) => (
  <List disablePadding>
    <ListItem divider>
      <Typography variant="body1">
        <T id="settings_notifications_title" />
      </Typography>
    </ListItem>
    {notificationSettings.notification.map((type, i) => (
      <ListItem key={i} divider style={{ paddingTop: 0, paddingBottom: 0 }}>
        <Grid container alignItems="center">
          <Grid item xs>
            <Typography variant="body2">{type.title}</Typography>
          </Grid>
          <Grid item>
            <Switch
              color="primary"
              checked={Boolean(type.enabled)}
              disabled={!type.available}
              onChange={() => onNotificationToggle(type.notificationId!, !type.enabled)}
            />
          </Grid>
        </Grid>
      </ListItem>
    ))}
  </List>
)

export default NotificationSwitchers
try {
    // @ts-ignore
    NotificationSwitchers.displayName = "NotificationSwitchers";
    // @ts-ignore
    NotificationSwitchers.__docgenInfo = { "description": "", "displayName": "NotificationSwitchers", "props": { "notificationSettings": { "defaultValue": null, "description": "", "name": "notificationSettings", "required": true, "type": { "name": "any" } }, "onNotificationToggle": { "defaultValue": null, "description": "", "name": "onNotificationToggle", "required": true, "type": { "name": "(id: string, enabled: boolean) => any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/routes/Settings/SettingsScreen/components/NotificationSwitchers/NotificationSwitchers.tsx#NotificationSwitchers"] = { docgenInfo: NotificationSwitchers.__docgenInfo, name: "NotificationSwitchers", path: "src/routes/Settings/SettingsScreen/components/NotificationSwitchers/NotificationSwitchers.tsx#NotificationSwitchers" };
}
catch (__react_docgen_typescript_loader_error) { }